import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import T from 'i18n-react';
import NoImage from '../../../images/no-image.png';
import AppAvatar from '../Avatar/AppAvatar';

export const styles = (theme) => ({
  subtitle: {
    margin: theme.spacing(3, 0),
    fontWeight: 'bold',
  },
  relative: {
    position: 'relative',
  },
  card: {
    color: '#fff',
  },
  cardArea: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  cardContent: {
    padding: theme.spacing(2, 0),
  },
  description: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  image: {
    position: 'relative',
    width: '100%',
    paddingTop: '75%',
    borderRadius: theme.shape.borderRadius,
  },
  avatar: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
});

class Attractions extends React.Component {
  constructor(props) {
    super(props);

    this.attractionRenderer = this.attractionRenderer.bind(this);
  }

  cardRenderer(attraction, index) {
    const { classes, loaded } = this.props;

    return (
      <Card elevation={0} className={classes.card}>
        <CardActionArea
          disableRipple
          disableTouchRipple
          component="div"
          className={classes.cardArea}
        >
          <div className={classes.image}>
            <AppAvatar
              src={attraction.imageUrl || (loaded ? NoImage : '')}
              loaded={loaded}
              className={classes.avatar}
              variant="rounded"
            />
          </div>
        </CardActionArea>
        <CardContent className={classes.cardContent}>
          <Typography className={clsx(classes.description, 'text-break-all')}>
            {attraction.description}
          </Typography>
        </CardContent>
      </Card>
    );
  }

  attractionRenderer(attraction, index) {
    return this.cardRenderer(attraction, index);
  }

  displaySubtitle(): boolean {
    const { attractions = [] } = this.props;
    return attractions.length > 0;
  }

  subtitleRenderer() {
    const { classes, region, city } = this.props;
    const place = [region, city].filter((a) => a).join(' ');
    return (
      <Typography className={classes.subtitle}>
        {T.translate('business.attractions.subtitle', { place })}
      </Typography>
    );
  }

  render() {
    const { classes, attractions = [] } = this.props;

    return (
      <>
        {this.displaySubtitle() && (
          <>
            <Divider />
            {this.subtitleRenderer()}
          </>
        )}
        <div>
          {attractions.map((attraction, index) => (
            <div className={classes.relative} key={`area-attraction${index}`}>
              {this.attractionRenderer(attraction, index)}
            </div>
          ))}
        </div>
      </>
    );
  }
}

Attractions.propTypes = {
  loaded: PropTypes.bool,
  region: PropTypes.string,
  city: PropTypes.string,
  attractions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      imageUrl: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
};

export default Attractions;
